import _ from 'lodash';

import { default as SendFbMessageItem } from 'actions/composition/send_fb_message';
import AddGreetingSuggestion from '../greeting_suggestions/add_greeting_suggestion';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default class SendFBMessage {
  constructor(context) {
    this.context = context;
  }

  run({ compositionId, content, customerId }) {
    const composition = getCompositionsStore(this.context, customerId).findBy({ id: compositionId });
    if (!composition) {
      return;
    }

    const compositionContent = composition.toJs().content;
    _.forEach(content, (html, attr) => {
      compositionContent[attr] = html;
    });
    compositionContent.messageText = content.body;

    this.context.executeAction(AddGreetingSuggestion, {
      customerId,
      messageText: content.body,
    });

    this.context.executeAction(SendFbMessageItem, { compositionId, content: compositionContent });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composer/send_fb_message.js